let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9SyhI"), load("76XJy")]).then(() => parcelRequire('a4qOe'));